import { toast } from '@/hooks/errors/use-toast';
import { useTasks } from '@/contexts/task/TaskContext';

export const useCompletedTasksVisibility = () => {
  const { completedTasks, clearCompletedTasks } = useTasks();
  
  const handleClearCompletedTasks = (e: React.MouseEvent) => {
    e.stopPropagation();
    
    if (completedTasks.length === 0) return;
    
    clearCompletedTasks();
    
    toast({
      title: "Tasks cleared",
      description: `All completed tasks have been removed`,
      variant: "default",
    });
  };
  
  return {
    handleClearCompletedTasks
  };
};
